import { SERVER } from './server';
export const API: string = SERVER + '/api';
